import { useForm } from "V2.0/HomePages/Assistants/AssistantTools/CustomAPIs/components/Form/useForm";
import Form from "V2.0/HomePages/Assistants/AssistantTools/CustomAPIs/components/Form";
import { useEffect, useState } from "react";
import {
  keywordAnalysisNodeSchema,
  keywordAnalysisNodeTemplate,
  AnalysisType,
  keywordAnalysisNodeSchemaWithParameterDescriptionAndChoice,
} from "../../models/analysisNode";
import { Button } from "V2.0/common/button";
import { getConnectedEdges, useEdges } from "@xyflow/react";

function KeywordAnalysisNodeSettings(props) {
  const { node, setNodes, closePanel, notifyChange, options, setEdges } = props;
  const [analysisNodeSettings, setAnalysisNodeSettings] = useState({
    ...node?.data?.settings,
  });
  const [inputField] = useState({
    name: node?.data?.settings?.name || "",
    description: node?.data?.settings?.description || "",
    analysisType: node?.data?.settings?.analysisType,
    textSource: node?.data?.settings?.textSource,
    outputVariableName: node?.data?.settings?.outputVariableName,
    parameterDescription: node?.data?.settings?.parameter?.parameterDescription,
    parameterChoices: node?.data?.settings?.parameter?.parameterChoices,
  });
  const edges = useEdges();

  const { data, error, setError, handleChange, validate } = useForm(
    inputField,
    keywordAnalysisNodeSchemaWithParameterDescriptionAndChoice
  );

  function handleSave() {
    const { parameterDescription, parameterChoices, ...restData } = data;

    const existingParameterChoices =
      node?.data?.settings?.parameter?.parameterChoices;

    if (existingParameterChoices.length === parameterChoices.length) {
      const connectedEdges = getConnectedEdges([node], edges);
      const outgoingEdges = connectedEdges.filter(
        (connectedEdge) => connectedEdge.source === node.id
      );

      const outgoingChoices = outgoingEdges.reduce((acc, outgoingEdge) => {
        const { data } = outgoingEdge;
        const { value } = data;
        return {
          ...acc,
          [value]: outgoingEdge,
        };
      }, {});

      const existingChoices =
        node?.data?.settings?.parameter?.parameterChoices.reduce(
          (acc, choice, idx) => {
            return {
              ...acc,
              [idx]: choice,
            };
          },
          {}
        );

      const currentParameterChoices = parameterChoices.reduce(
        (acc, choice, idx) => {
          return {
            ...acc,
            [idx]: choice,
          };
        },
        {}
      );

      Object.keys(existingChoices).forEach((key) => {
        const existingChoice = existingChoices[key];
        const currentChoice = currentParameterChoices[key];

        if (existingChoice != currentChoice) {
          const outgoingEdge = outgoingChoices[existingChoice];
          setEdges((prevEdges) => {
            return prevEdges.map((prevEdge) => {
              if (prevEdge.id === outgoingEdge.id) {
                return {
                  ...prevEdge,
                  data: {
                    ...prevEdge.data,
                    value: currentChoice,
                  },
                };
              }

              return prevEdge;
            });
          });
        }
      });
    }

    const updatedDataWithParameter = {
      ...restData,
      parameter: {
        parameterName: data.outputVariableName,
        parameterDescription: data.parameterDescription,
        parameterType: analysisNodeSettings.parameter.parameterType,
        parameterChoices: data.parameterChoices,
      },
    };

    const errors = validate(
      data,
      keywordAnalysisNodeSchemaWithParameterDescriptionAndChoice
    );

    if (errors) {
      setError(errors);
      return;
    }

    const payload = {
      ...analysisNodeSettings,
      ...updatedDataWithParameter,
    };

    setNodes((prevNodes) => {
      const updatedNodes = prevNodes.map((_node) => {
        if (_node.id === node.id) {
          const { selected, ...rest } = _node;
          return {
            ...rest,
            selected: false,
            data: {
              ...node.data,
              settings: {
                ...payload,
              },
            },
          };
        } else {
          return _node;
        }
      });
      return updatedNodes;
    });
    closePanel();
    notifyChange();
  }

  useEffect(() => {
    if (options?.triggerSave) {
      handleSave();
    }
  }, [options]);

  return (
    <div>
      {/* <p>{JSON.stringify(analysisNode.availableStatuses)}</p> */}
      <Form
        data={data}
        handleChange={handleChange}
        template={keywordAnalysisNodeTemplate}
        error={error}
      />
      <div className="flex justify-end">
        <Button onClick={handleSave}>Save</Button>
      </div>
    </div>
  );
}

export { KeywordAnalysisNodeSettings };
